import React from 'react'

/**
 * Hook to listen for click event outside of ref
 * @param {RefObject} ref Ref to element to watch
 * @param {function} callback Callback function fired when clicked outside.
 * @param enabled
 */
export default function useOutsideClickHandler(ref, callback, enabled = true) {
  const clickedOnScrollbar = (mouseX) => document.body.clientWidth <= mouseX

  const handleClickOutside = React.useCallback(
    (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        if (!clickedOnScrollbar(event.clientX)) {
          if (enabled) {
            callback()
          }
        }
      }
    },
    [ref, enabled, callback]
  )

  React.useEffect(() => {
    if (enabled) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [enabled, handleClickOutside])
}
